module.exports = __webpack_public_path__ + "static/media/community-b.680b26ac.svg";